// ── TAG Platform Constants ─────────────────────────────────────────────────
// Change TAG_DISCORD_URL here and it updates everywhere on the site.

export const TAG_DISCORD_URL = "https://discord.gg/matmFhU4yg"; // TODO: replace with official TAG support Discord
